"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.View = void 0;
exports.View = {
  name: 'View',
  label: 'View',
  type: 'taxonomy',
  useDuplicateCheck: false,
  icon: function (_a) {
    var icons = _a.icons;
    return icons.Entities.Post;
  },
  autoRoutes: ['list', 'create', 'update'],
  table: {
    fieldNames: ["name", "type", "slices", "childEntityTypes"],
    fields: {
      name: {
        weight: 1
      },
      type: {
        weight: 1.5
      },
      childEntityTypes: {
        title: "Child Entity Types",
        weight: 2
      },
      slices: {
        weight: 2
      }
    }
  },
  form: {
    modal: {
      fill: true,
      maxWidth: '1200px'
    },
    fieldSets: [{
      name: 'overview'
    }, {
      name: 'slices'
    }],
    fields: {
      label: {
        type: 'text',
        description: "Provide an alternative label used for displaying this {{VIEW}}. If not provided, the name will be used instead."
      },
      hash: {
        type: 'text',
        description: "Provide a unique hash ID for the view, which will be used by URL state when changing to the view. If not provided this will be a kebab-case version of the name."
      },
      type: {
        type: 'linked',
        entityTypeName: 'ViewType',
        label: 'Type',
        description: 'What type of {{VIEW}} is this?'
      },
      layout: {
        type: 'linked',
        entityTypeName: 'ViewLayout',
        label: 'Layout',
        description: 'Select an alternative layout for this {{VIEW}}, if required. If not specified, this will generally show all of the {{SLICE}} content provided for the given {{SLICE_LAYOUTS}} listed above.'
      },
      icon: {
        type: 'linked',
        entityTypeName: 'Icon'
      },
      slices: {
        type: 'linkedTable',
        entityTypeName: 'Slice',
        fieldSet: 'slices',
        label: 'Slice Layouts',
        description: 'Specify which {{SLICE_LAYOUTS}} are used to render this {{VIEW}}? This essentially determines the conte twhich will be available to edit in pages and screens rendering this {{VIEW}}'
      },
      showCount: {
        type: 'boolean',
        label: 'Show Count?',
        description: 'Should the number of items in this {{VIEW}} be displayed in the UI?'
      },
      childEntityTypes: {
        type: 'linkedMultiple',
        entityTypeName: 'EntityType',
        label: 'Child Entity Types',
        description: 'Which child {{ENTITY_TYPES}} does this {{VIEW}} encompass? This helps to auto-select an active tab for a top level view such as an explorer. That is, if a given {{ENTITY_TYPE}} is listed here, this view will render as the active tab in top level explorer tabs when a page of that type is currently displayed.'
      }
    }
  }
};